import { createFileRoute } from '@tanstack/react-router'
import React from 'react'
import { SiteWhatsapp } from '../site/components/site-whatsapp'

export const Route = createFileRoute('/_auth/_main/websites/$siteId/settings/whatsapp')({
    component: Whatsapp,
})

function Whatsapp() {
    const { siteId } = Route.useParams()

    return <SiteWhatsapp siteId={siteId} />
}
